/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Wrong_QuestionInputs */

const en_faq_wrong_question = /** @type {(inputs: Faq_Wrong_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if the system gets something wrong?`)
};

const lv_faq_wrong_question = /** @type {(inputs: Faq_Wrong_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas notiek, ja sistēma kļūdās?`)
};

/**
* | output |
* | --- |
* | "What if the system gets something wrong?" |
*
* @param {Faq_Wrong_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_wrong_question = /** @type {((inputs?: Faq_Wrong_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Wrong_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_wrong_question(inputs)
	return en_faq_wrong_question(inputs)
});